import * as THREE from "three";
import Orchestrator from "../Orchestrator.js";
import { CONFIG, columnX, columnZ, surfaceY } from "./config.js";

export default class Debris {
    constructor() {
        this.orc = new Orchestrator();
        this.scene = this.orc.scene;

        this.pieces = [];
        this.geometry = new THREE.BoxGeometry(0.13, 0.13, 0.13);
        this.material = new THREE.MeshLambertMaterial({ color: 0xb35c30 });
    }

    spawn(i, j, blockY) {
        for (let n = 0; n < CONFIG.DEBRIS_PER_DIG; n++) {
            const mesh = new THREE.Mesh(this.geometry, this.material);
            mesh.position.set(
                columnX(i) + (Math.random() - 0.5) * 0.75,
                surfaceY(blockY) + (Math.random() - 0.5) * 0.45,
                columnZ(j) + (Math.random() - 0.5) * 0.75,
            );
            this.scene.add(mesh);
            this.pieces.push({
                mesh,
                vx: (Math.random() - 0.5) * 3.6,
                vy: 1.5 + Math.random() * 3.4,
                vz: (Math.random() - 0.5) * 3.6,
                life: 0.85,
            });
        }
    }

    update(dt) {
        for (let n = this.pieces.length - 1; n >= 0; n--) {
            const piece = this.pieces[n];
            piece.life -= dt;
            if (piece.life <= 0) {
                this.scene.remove(piece.mesh);
                this.pieces.splice(n, 1);
                continue;
            }

            piece.vy -= 14 * dt;
            piece.mesh.position.x += piece.vx * dt;
            piece.mesh.position.y += piece.vy * dt;
            piece.mesh.position.z += piece.vz * dt;
            piece.mesh.rotation.x += dt * 7;
            piece.mesh.rotation.y += dt * 5;
            piece.mesh.scale.setScalar(Math.max(0.05, piece.life / 0.85));
        }
    }

    clear() {
        for (const piece of this.pieces) {
            this.scene.remove(piece.mesh);
        }
        this.pieces.length = 0;
    }
}
